"use client"

import type { JobAdDetail } from "@/modules/jobAdDetail/types"
import type { FunctionComponent } from "react"

import { Text } from "@jobteaser/spark/components/Text"

import { RichTextElement } from "@/modules/kontent/components/RichTextElement"

import { ReadMore } from "./ReadMore"

import styles from "./Description.module.css"

type DescriptionProps = {
  data: JobAdDetail
  seeLessLabel: string
  seeMoreLabel: string
}

export const Description: FunctionComponent<DescriptionProps> = ({ data, seeLessLabel, seeMoreLabel }) => {
  return (
    <article className={styles.main} data-testid="jobad-DetailView__Description">
      <ReadMore seeLessLabel={seeLessLabel} seeMoreLabel={seeMoreLabel}>
        <Text as="div" variant="body1" weight="regular" className={styles.content}>
          {data.richTextDescription.map((elementProps, index) => (
            <RichTextElement
              {...elementProps}
              // eslint-disable-next-line react/no-array-index-key
              key={`${elementProps.type}_${index}`}
            />
          ))}
        </Text>
      </ReadMore>
    </article>
  )
}
